<script lang="ts">
    import { analytics, analyticsIdentify, analyticsTrack } from "$lib/analytics";
    import Hero from '../../components/section/Hero.svelte';
    import Steps from '../../components/section/Steps.svelte';
    import Numbers from "../../components/section/Numbers.svelte";
    import Articles from '../../components/section/Articles.svelte';
    import FreeTextArea from '../../components/section/FreeTextArea.svelte';
    import Container from '../../components/containers/Container.svelte';
    import Wave from "../../components/elements/Wave.svelte";
    import LinkSection from "../../components/section/LinkSection.svelte";
    import sanityImage from "../../sanity/sanityImage";
    import Schema from "../../components/seoSchema/Schema.svelte";
    import TieredPricing from "../../components/section/TieredPricing.svelte";
    import MarketPlacePreview from "../../components/section/MarketPlacePreview.svelte";
    import SignUpPopUp from "../../components/elements/SignUpPopUp.svelte";
    import ProductReviews from "../../components/section/ProductReviews.svelte";
    import { onMount } from "svelte";

    export let data : any;
    //Segment loading

    onMount(() => {
        analytics.page();
    })

    const { g2, offerzen_rating, title, meta, slug, free_text } = data.page[0]

    const gakey = import.meta.env.VITE_GA_KEY;

    let showPopUp : boolean = false


    const handleShowPopUp = (param) => {
        showPopUp = !showPopUp
        showPopUp ? document.body.style.overflow = "hidden" : document.body.removeAttribute('style');

        if(param) {
            analyticsTrack('Company: Candidate Preview List Action', {
                ...param,
                source: 'demand marketing page',
                source_detail: 'view candidate',
                action: 'clicked candidate card',
                category: 'marketing pages',
                label: 'organic demand role page'
            })
        }
    }

    const handleOutsidePopUpClick = () => {
        showPopUp = false
        showPopUp ? document.body.style.overflow = "hidden" : document.body.removeAttribute('style');
    }
</script>
<svelte:head>
    <title>{data.page[0].meta.page_title}</title>
    <Schema 
    name="{title}s" 
    slug={slug.current} 
    accordionContent={free_text} 
    reviewRating={{
        name: meta.page_title,
        description: meta.page_description,
        value: offerzen_rating?.rating_copy,
        total: offerzen_rating.total_reviews
    }}
    userReviews={g2}
    />
    <meta name="description" content={data.page[0].meta.page_description}>
    <title>{data.page[0].meta.page_title}</title>
    <meta property="og:image" content={data.page[0].meta.image} />
    <meta property="og:title" content={data.page[0].meta.page_title} />
    <meta property="og:description" content={data.page[0].meta.page_description} />
    <meta property="og:type" content="website" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={data.page[0].meta.page_title} />
     <!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id={gakey}"></script>
    <link rel="canonical" href="https://www.offerzen.com/hire-developers/{data.page[0].slug.current}" />
    <!-- Google Tag Manager -->
    {@html `
        <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-WTG6R2B');</script>`}
        <!-- End Google Tag Manager -->

</svelte:head>
<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WTG6R2B"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
 <!-- End Google Tag Manager (noscript) -->
<Hero 
    heading={data.page[0].hero.heading} 
    description={data.page[0].hero.description} 
    image={data.page[0].hero.image} 
    reviewRating={offerzen_rating}
    {title}
/>
<div style="background-color:#eef3f6">
    <Wave rotate={true} className="wave-top"/>
    <Container background="lightgrey" padding="none">
        <MarketPlacePreview 
            heading={data.page[0].candidate_search?.heading} 
            skills={data.page[0].candidate_search?.skills} 
            roles={data.page[0].candidate_search?.roles} 
            handleShowPopUp={handleShowPopUp}
        />
        <SignUpPopUp showPopUp={showPopUp} {handleOutsidePopUpClick}/>
    </Container>
    {#if g2 && g2?.length > 0 }<Wave waveColor="white" rotate={false}/>{/if}
</div>
{#if g2 && g2?.length > 0}
    <Container background="white" padding="none">
        <ProductReviews generalReview={data.page[0]?.offerzen_rating} reviews={g2}/>
    </Container>
{/if}
<div class="space-background">
    {#if g2 && g2?.length > 0 }<Wave waveColor="white" rotate={true}/>{:else}<Wave rotate={false} waveColor="lightgrey"/>{/if}
    <Container background="transparent" mobileBackgroundColor="midnight">
        <Numbers/>
        <Steps
            title="Hire your next <span>{data.page[0].title}</span> on OfferZen in 4 steps"
            steps={
                [
                    {
                        heading: data.page[0].hire_steps[0].heading,
                        description: data.page[0].hire_steps[0].description,
                        image: 'OfferZen_demand_Sign_up'
                    },
                    {
                        heading: data.page[0].hire_steps[1].heading,
                        description: data.page[0].hire_steps[1].description,
                        image: 'OfferZen_demand_browse_developers'
                    },
                    {
                        heading: data.page[0].hire_steps[2].heading,
                        description: data.page[0].hire_steps[2].description,
                        image: 'OfferZen_demand_Interview_stand_outs'
                    },
                    {
                        heading: data.page[0].hire_steps[3].heading,
                        description: data.page[0].hire_steps[3].description,
                        image: 'OfferZen_Demand_Hire_25'
                    }
                ]
            }
        />
    </Container>
</div>
<div class="space-background space-background--light">
    <Wave waveColor="dark" rotate={false}/>
    <TieredPricing/>
    <Container background="transparent">
        <Steps
            title="What makes OfferZen different for <span>{data.page[0].title}</span> hiring?"
            steps={
                [
                    {
                        heading: 'Candidate quality',
                        description: 'Developers on our platform have been curated by our team for skill and intent to change jobs.',
                        image: 'OfferZen_demand_Candidate_quality'
                    },
                    {
                        heading: 'Transparent developer profiles',
                        description: 'Candidate profiles include their career aspirations, skill sets, work histories, citizenship status and expected salary.',
                        image: 'OfferZen_demand_Transparent_developer_profiles'
                    },
                    {
                        heading: 'AI-powered sourcing and matching',
                        description: 'Match with candidates based on your open roles, or search for candidates using advanced search criteria.',
                        image: 'OfferZen_demand_Simplified_sourcing_matching'
                    },
                    {
                        heading: 'Expert tech hiring guidance',
                        description: 'Access position-relevant salary benchmarks, objective feedback from candidates, and more with your Account Manager.',
                        image: 'OfferZen_demand_Expert_tech_hiring_guidance'
                    }
                ]
            }
        />
    </Container>
    <Wave waveColor="white" />
</div>
<FreeTextArea
    heading={data.page[0].free_text_heading}
    blockContent={data.page[0].free_text}
    introductionParagraph={data.page[0].free_text_paragraph}
    showBanner={data.page[0].free_text_banner}
    bannerHeading={data.page[0].free_text_banner ? data.page[0].banner_content.heading : ''}
    bannerContent={data.page[0].free_text_banner? data.page[0].banner_content.content : ''}
    bannerCTA={{
        text: data.page[0].free_text_banner ? data.page[0].banner_content.cta_text : '',
        url: data.page[0].free_text_banner ? data.page[0].banner_content.link : ''
    }}
    bannerImage={{
        pngUrl: data.page[0].free_text_banner ? sanityImage(data.page[0].banner_content.image.asset._ref) : '',
        alt: data.page[0].free_text_banner ? data.page[0].banner_content.image.alt : ''
    }}
/>
<Wave rotate={false}/>
<Articles
    title={data.page[0].article_section.heading}
    articles={data.page[0].article_section.articles}
/>
<div class="space-background">
    <Wave rotate={true}/>
    <LinkSection list={data.urlList}/>
</div>
<style lang="postcss">
@import '../../styles/_mixins.css';

.space-background {

    background: url('/assets/spacebackground_solid.svg'),
        linear-gradient(
            to bottom,
            var(--color_offerzen_navy) 0%,
            var(--color_offerzen_navy) 50%,
            var(--color_white) 50%,
            var(--color_white) 100%
    );
    background-position:center;
    background-size:cover;

    @mixin screen-sm {
        background-image: none;
        background-color:var(--color_offerzen_midnight);
    }
}

.space-background--form {
    background: url('/assets/spacebackground_solid.svg'),
        linear-gradient(
            to bottom,
            var(--color_white) 0%,
            var(--color_white) 50%,
            var(--color_offerzen_navy) 50%,
            var(--color_offerzen_navy) 100%
    );
    background-position:center;
    background-size:cover;

    @mixin screen-sm {
        background-image: none;
        background-color:var(--color_offerzen_midnight);
    }
}

.space-background--light {
    background-image: url('/assets/background-space-light.svg');
    background-color: var(--color_white);

    @mixin screen-sm {
        background-image: none;
        background-color:var(--color_offerzen_navy);
    }
}

:global(.wave-top) {
    max-height:150px !important;
}

</style>

